/**
 * 国际化配置
 */
import zhCN from './zh-CN'
import enUS from './en-US'
import esES from './es-ES'
import jaJP from './ja-JP'
import koKR from './ko-KR'
import frFR from './fr-FR'
import deDE from './de-DE'
import arSA from './ar-SA'

export default {
  'zh-CN': zhCN,
  'en-US': enUS,
  'es-ES': esES,
  'ja-JP': jaJP,
  'ko-KR': koKR,
  'fr-FR': frFR,
  'de-DE': deDE,
  'ar-SA': arSA
}